export default function CmsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
    >
      <path
        d="M17.266 2.64924C19.8683 1.9411 21.8172 2.00414 22.3922 3C23.4277 4.7936 19.6144 8.93389 13.8749 12.2476C8.13539 15.5613 2.64313 16.7936 1.60759 15C1.03273 14.0043 1.95217 12.2854 3.86591 10.3862M20.2499 9C20.2499 13.5563 16.5562 17.25 11.9999 17.25C7.44355 17.25 3.7499 13.5563 3.7499 9C3.7499 4.44365 7.44355 0.75 11.9999 0.75C16.5562 0.75 20.2499 4.44365 20.2499 9Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
